import React, { FC } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import DangerouslySetInnerHtml from 'components/common/DangerouslySetInnerHtml';
import AccordionCustom from 'components/common/AccordionCustom';
import Label from 'components/common/Label';
import HTag from 'components/common/HTag';
import MediaInfoBox from 'components/common/MediaInfoBox/MediaInfoBox';
import Media from 'components/common/MediaInfoBox/Media';
import UmbracoImage from 'components/common/Image/UmbracoImage';
import { IHowToUse } from './models';

import './HowToUse.scss';

const HowToUse: FC<IHowToUse> = (props) => (
  <div className="dt-how-to-use">
    <HTag size={3} regularText={props.titleRegular} boldText={props.titleBold} />
    <Row>
      <Col md={{ span: 10, offset: 1 }}>
        <DangerouslySetInnerHtml className="dt-how-to-use__text" html={props.description} />
      </Col>
    </Row>

    {props.image && props.imageAlt ? (
      <div className="dt-how-to-use__video">
        <Label type="info">{props.actionLabelText}</Label>
        <MediaInfoBox isFullWidth>
          <Media video={props?.videoUrl}>
            <UmbracoImage image={props.image} alt={props.imageAlt} />
          </Media>
        </MediaInfoBox>
      </div>
    ) : null}
    {props.listTitleText ? <h2 className="dt-how-to-use__title">{props.listTitleText}</h2> : null}
    {props.recommendations && props.recommendations.length > 0 ? (
      <AccordionCustom data={props.recommendations} />
    ) : null}
  </div>
);

export default HowToUse;
